<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>    
    <h3 class="text-center"> Modificar Semaforo </h3>
    <p class="text-center text-primary" style="margin-bottom:0"> <small class="center-block"> <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios </small> </p>
  
    <!-- <p> {{semaforo.id}} sede: {{semaforo.idsede}} </p> -->
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': validation.hasError('semaforo.meta1')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Inicia </div>
            <Fecha :model="semaforo" :valueto="'inicio'" :default="semaforo.inicio"/>
          </div>
          <div class="error" v-if="validation.hasError('semaforo.meta1')"> {{validation.firstError('semaforo.meta1')}} </div>
        </div>

        <div class="form-group" :class="{'has-error': validation.hasError('semaforo.meta1')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Finaliza </div>
            <Fecha :model="semaforo" :valueto="'fin'" :default="semaforo.fin"/>
          </div>
          <div class="error" v-if="validation.hasError('semaforo.meta1')"> {{validation.firstError('semaforo.meta1')}} </div>
        </div>

        <div class="form-group" :class="{'has-error': validation.hasError('semaforo.meta1')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Diplomados </div>
            <input type="text" v-model.trim="semaforo.meta1" class="form-control" placeholder="Cantidad numerica">
          </div>
          <div class="error" v-if="validation.hasError('semaforo.meta1')"> {{validation.firstError('semaforo.meta1')}} </div>
        </div>

        <div class="form-group" :class="{'has-error': validation.hasError('semaforo.meta2')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Especialidades </div>
            <input type="text" v-model.trim="semaforo.meta2" class="form-control" placeholder="Cantidad numerica">
          </div>
          <div class="error" v-if="validation.hasError('semaforo.meta2')"> {{validation.firstError('semaforo.meta2')}} </div>
        </div>

        <div class="form-group" :class="{'has-error': validation.hasError('semaforo.meta3')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> <span class="text-danger">*</span> Maestrias </div>
            <input type="text" v-model.trim="semaforo.meta3" class="form-control" placeholder="Cantidad numerica">
          </div>
          <div class="error" v-if="validation.hasError('semaforo.meta3')"> {{validation.firstError('semaforo.meta3')}} </div>
        </div>
      </div>
      <div class="col-sm-6">
        <Usuarios :model="semaforo" :idsede="semaforo.idsede" :multiple="true" :xdefault="semaforo.users"/>
      </div>
    </div>

    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />

    <button :disabled="!activo" type="button" class="btn btn-sm btn-azul" @click="validarCampos()"> <span class="glyphicon glyphicon-ok"></span> Guardar Cambios </button>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Fecha from '@/components/AFecha'
import Alertas from '@/components/AAlertas.vue'
import Usuarios from '@/components/AUsuariosSemaforo.vue'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      activo: true,
      usuario:{users:[]},
      semaforo: {players:[],idusuario:[]},
    }
  },
  components:{Fecha,Alertas,Usuarios},
  validators: {
    'semaforo.inicio'(value){
      return Validator.value(value).required();
    },
    'semaforo.fin'(value){
      return Validator.value(value).required();
    },
    'semaforo.meta1'(value){
      return Validator.value(value).integer().minLength(1).maxLength(2).greaterThan(0).required();
    },
    'semaforo.meta2'(value){
      return Validator.value(value).integer().minLength(1).maxLength(2).greaterThan(0).required();
    },
    'semaforo.meta3'(value){
      return Validator.value(value).integer().minLength(1).maxLength(2).greaterThan(0).required();
    },
    /*'semaforo.players'(value){
      return Validator.value(value).required();
    },*/
  },
  
  methods:{
    validarCampos(){
      this.$validate().then((success) => {
        window.console.log( "jajajajajaajajj" );
        var obj = window.Object.assign( {},this.semaforo );
        if( obj.meta1 != null ) obj.meta1 = window.parseInt( obj.meta1 );
        if( obj.meta2 != null ) obj.meta2 = window.parseInt( obj.meta2 );
        if( obj.meta3 != null ) obj.meta3 = window.parseInt( obj.meta3 );
        if( obj.meta4 != null ) obj.meta4 = window.parseInt( obj.meta4 );
        if (success) {
            delete obj.semaforo_usuario;
            delete obj.nombre;
            delete obj.users;
            delete obj.__typename;
            delete obj.meta4; /// esto no hay en servidor todavia
            obj.fechas = {fecha_ini:obj.inicio+'T23:59:00.000Z',fecha_fin:obj.fin+'T23:50:00.000Z'}
            delete obj.inicio;
            delete obj.fin;
            obj.players = [];
            window.console.log( "jajajajajaajajj",obj );
            obj.idusuario.forEach( function(e){
              obj.players.push( e.id )
            })
            delete obj.idusuario;
            // estas acciones van en par, set el objeto para luego limpiar campos nulos
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');

            this.activo = false;
            this.$refs.alertar.cargando();
            //window.console.log( "SSSSS",window.stringifyObject(obj) );
            this.enviarDatos( obj );
        }else{
            //window.console.log( "HHHHH",window.stringifyObject(obj) );
            this.$refs.alertar.invalido();
        }
      });
    },
    enviarDatos( obj ){
      window.console.log( "jejeje",obj )
      var vue = this;
      var sql = gql`mutation{ updateSemaforoGame(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      window.console.log( sql )

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if(data.data.updateSemaforoGame.ok){
          vue.$refs.alertar.success();
          this.activo = true;
          /*setTimeout(function(){
            vue.$router.push('semaforo')
          },2000)*/
        }else{
          var errores = JSON.stringify(data.data.updateSemaforoGame.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.activo = true;
          vue.$refs.alertar.invalido( vals );
        }

        window.console.log(data);
      }).catch((error) => {
        vue.activo = true;
        window.console.error(error);
        vue.$refs.alertar.invalido();
      })
    }
  },
  mounted(){
    var s = window.sessionStorage.getItem( 'xsemaforo');
    if( s != null){
      this.semaforo = JSON.parse( s )
      var d1 = new Date(this.semaforo.inicio);
      var d2 = new Date(this.semaforo.fin);
      var di1 = d1.getDate();
      var di2 = d2.getDate();
      var me1 = d1.getMonth()+1;
      var me2 = d2.getMonth()+1;
      if( di1 < 10  ) di1 = '0'+di1;
      if( di2 < 10  ) di2 = '0'+di2;
      if( me1 < 10  ) me1 = '0'+me1;
      if( me2 < 10  ) me2 = '0'+me2;
      this.semaforo.inicio = d1.getFullYear()+'-'+me1+'-'+di1;
      this.semaforo.fin = d2.getFullYear()+'-'+me2+'-'+di2;
      var users = [];

      this.semaforo.semaforo_usuario.forEach( function(e){
        var dp = e.usuario.datos_personales;
        var seg = dp.seg_apellido==null?'':dp.seg_apellido;
        var no = dp.nombres+" "+dp.pri_apellido+" "+seg;
        users.push( {id:e.usuario.id,nombres:no} )
      })
      this.semaforo.users = users;
      window.console.log( "SEMFORO MOD",this.semaforo )
    }else{
      this.$route.push('/semaforo')
    }
    
  }
}
</script>